import { Tooltip } from "antd";
import React, { useState } from "react";
import { MultiSelect } from "react-multi-select-component";
// import ReactTooltip from 'react-tooltip';

const Search: React.FC = (props) => {
  let stores = [];

  let storesData = [];
  let NotCheckedStoresData = [];

  if (props.allStore.storeInfo && props.userSelected) {
    props.allStore.storeInfo.map((val) => {
      if (val.activeFlag === 1) {
        storesData.push({
          label: val.storeName,
          value: val.storeId,
        });
      }
      if (!NotCheckedStoresData.some((store) => store.value === val.storeId))
        NotCheckedStoresData.push({
          label: val.storeName,
          value: val.storeId,
        });
    });
    if (props.someRV) {
      props.storeData.stores.map((val) => {
        if (val.activeFlag === 1) {
          storesData.push({
            label: val.storeName,
            value: val.storeId,
          });
        }
        if (!NotCheckedStoresData.some((store) => store.value === val.storeId))
          NotCheckedStoresData.push({
            label: val.storeName,
            value: val.storeId,
          });
      });
    }
  }
  const [selected, setSelected] = useState(storesData);

  const finalStores = [];

  selected.map((val) => {
    finalStores.push(val.label);
  });
  const tooltipdata =
    finalStores.length > 0
      ? JSON.stringify(finalStores).replace("[", "").replace("]", "")
      : "Please select stores";
  return (
    <div className="tooltip-main">
      <Tooltip
        title={tooltipdata}
        placement="right"
        overlayInnerStyle={{ width: "480px" }}
      >
        <MultiSelect
          className="multiSelectAll"
          options={NotCheckedStoresData}
          value={selected}
          onChange={setSelected}
          labelledBy={stores.storeName}
          overrideStrings={{
            selectSomeItems: "Search for stores",
            allItemsAreSelected: "All stores are selected.",
            selectAll: "Select All",
            search: "Search",
          }}
        />
        {localStorage.setItem(
          "multisearchall",
          JSON.stringify({ type: props.name, data: JSON.stringify(selected) })
        )}
      </Tooltip>
    </div>
  );
};

export default Search;
